export const MAIN_COLOR = "#5C41D8";

export const SECONDARY_COLOR = "#DD4465";

export const GREEN_COLOR = "#77C598";

export const YELLOW_COLOR = "#F4B747";

export const MAIN_COLOR_DARKER = "#4825cf";
